import { Course, Genre, Menu, MenuBook, SubGenre } from '../../models';
import SubMenuGroupRow from '../SubMenuGroupRow';
import SubMenuRowList from '../SubMenuRowList';

export interface SubMenuGroupRowListProps {
  menuBook: MenuBook;
  course?: Course;
  genre: Genre;
  subgenre: SubGenre;
  menu: Menu;
}

function SubMenuGroupRowList({ menuBook, course, genre, subgenre, menu }: SubMenuGroupRowListProps) {
  return (
    <>
      {menu.sub_menu_groups.map((subMenuGroup) => (
        <SubMenuGroupRow
          key={`submenugroup-${subMenuGroup.id}`}
          menuBook={menuBook}
          course={course}
          genre={genre}
          subgenre={subgenre}
          menu={menu}
          subMenuGroup={subMenuGroup}
        >
          <SubMenuRowList
            menuBook={menuBook}
            course={course}
            genre={genre}
            subgenre={subgenre}
            menu={menu}
            subMenuGroup={subMenuGroup}
          />
        </SubMenuGroupRow>
      ))}
    </>
  );
}

export default SubMenuGroupRowList;
